inputs-search-checkbox
  div(class="form-group row { error: opts.errors }")
    input(type="hidden" value="{ opts.value }" name="{ opts.name }" )
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      span(each="{opts.items}")
        .checkbox-fade.fade-in-primary
          label
            input(type="checkbox" value="{ value }" onClick="{ this.onChange }" checked="{checked}")
            span.cr
              i.cr-icon.icofont.icofont-ui-check.txt-primary
            span { label }
  script(type="typescript").
    this.mixin('inputs.search.checkbox');
